export const openSmartsuppChat = (systemName) => {
    window?.smartsupp?.('variables', {
        Sistema: systemName,
    })
    window?.smartsupp?.('chat:show')
    window?.smartsupp?.('chat:open')
}

export const hideSmartsuppChat = () => {
    window?.smartsupp?.('chat:hide')
}
